import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { PackStatus } from 'app/typings/core/admin/packs/enum/pack';
import type { SearchPackResponse } from 'app/typings/core/admin/packs/packList';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type PacksListQueryParam = {
  search?: string;
  sorting?: string;
  status?: PackStatus[];
  pageNumber?: number;
};

export function usePacks(queryParams: PacksListQueryParam = {}) {
  const formattedQueryParams = useMemo(() => {
    return {
      ...queryParams,
    };
  }, [queryParams]);

  const key = useMemo(() => {
    return [
      CORE_QUERY_KEYS.packs,
      {
        ...formattedQueryParams,
      },
    ];
  }, [formattedQueryParams]);

  return useQuery({
    queryKey: key,
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getPacks,
        queryParams: formattedQueryParams,
      }) as Promise<SearchPackResponse>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
  });
}
